package com.exura.pages.planCreator.components.seriesViews.inputs

import androidx.compose.runtime.*
import com.exura.ui.*
import com.exura.ui.modifiers.insetHoverableItemStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

data class ModeOption<T: Enum<*>>(
    val onClick: () -> Unit = {  },
    val content: @Composable () -> Unit = {  },
)

@Composable
internal fun <T: Enum<*>> ModeSelectorInput(
    options: List<T>,
    optionToMode: (T) -> ModeOption<T>,
    selectedValue: T,
    mode: PlanCreatorInputMode,
    enabled: Boolean = true,
    modifier: Modifier = Modifier
) {
    if (enabled) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(8.px),
            verticalAlignment = Alignment.CenterVertically,
            modifier = modifier.fillMaxSize(),
        ) {
            options.forEach { option ->
                val modeOption = optionToMode(option)
                val isSelected = selectedValue == option
                val isInteractive = enabled && mode == PlanCreatorInputMode.EDIT

                ModeSelectionOption(
                    optionMode = modeOption,
                    modifier = Modifier.weight(1f),
                    isSelected = isSelected,
                    isInteractive = isInteractive,
                )

            }
        }
    }
}

@Composable
private fun <T: Enum<*>> ModeSelectionOption(
    optionMode: ModeOption<T>,
    modifier: Modifier = Modifier,
    isSelected: Boolean = false,
    isInteractive: Boolean = false,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .insetHoverableItemStyle(
                isSelected = isSelected,
                shadeColor = ExuraColors.BLUE.copy(alpha = 0.1),
                shadeSize = 8.px,
                hoverColor = if (isInteractive) ExuraColors.BLUE.copy(alpha = 0.05) else ExuraColors.TRANSPARENT,
                selectedColor = ExuraColors.BLUE.copy(alpha = 0.15),
                cursor = if (isInteractive) Cursor.Pointer else Cursor.Default,
                onClick = if (isInteractive) {
                    { optionMode.onClick() }
                } else null,
                isHoverable = isInteractive
            )
            .padding(8.px)
            .borderRadius(8.px)
            .then(modifier),
        contentAlignment = Alignment.Center,
    ) {
        optionMode.content()
    }
}
